const apiBaseUrl = 'https://gohaulier.com';

export function getFullUrl(relatiiveUrl) {
  return `${apiBaseUrl}${relatiiveUrl}`;
}

export function isBingMapLoaded() {
  return !!(
    window.Microsoft
    && window.Microsoft.Maps
    && window.Microsoft.Maps.Map
  );
}

export function humanizeDate(date, format = 'MMMM Do YYYY') {
  const moment = require('moment');
  return moment(date).format(format);
}

export function humanizeDateFromSeconds(seconds, format = 'hh:mm') {
  const moment = require('moment');
  return moment(new Date(seconds * 1000)).format(format);
}

export function ordanizeNumber(number) {
  if (number % 100 >= 11 && number % 100 <= 13) return `${number}th`;

  /* eslint-disable default-case */
  switch (number % 10) {
    case 1:
      return `${number}st`;
    case 2:
      return `${number}nd`;
    case 3:
      return `${number}rd`;
  }

  return `${number}th`;
}

export function enumerateDaysBetweenDates(startDate, endDate) {
  const moment = require('moment');

  const date = [];
  let currentDate = startDate;
  while (currentDate <= endDate) {
    date.push(currentDate);
    currentDate = moment(currentDate)
      .add(1, 'days')
      .format('YYYY-MM-DD');
  }
  return date;
}

export function downloadCsv(csv, filename) {
  const hiddenElement = document.createElement('a');
  hiddenElement.href = `data:text/csv;charset=utf-8,${encodeURI(csv)}`;
  hiddenElement.target = '_blank';
  hiddenElement.download = `${filename}.csv`;
  hiddenElement.click();
}
